// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BlendedMarketDataFromJSON, BlendedMarketDataToJSON, MarketTypeFromJSON, MarketTypeToJSON, UserDefinedMarketDataFromJSON, UserDefinedMarketDataToJSON, } from './';
export function MarketResponseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'marketType': !exists(json, 'marketType') ? undefined : MarketTypeFromJSON(json['marketType']),
        'vintage': !exists(json, 'vintage') ? undefined : json['vintage'],
        'geography': !exists(json, 'geography') ? undefined : json['geography'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'createdAt': !exists(json, 'createdAt') ? undefined : new Date(json['createdAt']),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'assetClass': !exists(json, 'assetClass') ? undefined : json['assetClass'],
        'numberOfFunds': !exists(json, 'numberOfFunds') ? undefined : json['numberOfFunds'],
        'userDefinedData': !exists(json, 'userDefinedData') ? undefined : UserDefinedMarketDataFromJSON(json['userDefinedData']),
        'blendedData': !exists(json, 'blendedData') ? undefined : BlendedMarketDataFromJSON(json['blendedData']),
    };
}
export function MarketResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'source': value.source,
        'currency': value.currency,
        'description': value.description,
        'marketType': MarketTypeToJSON(value.marketType),
        'vintage': value.vintage,
        'geography': value.geography,
        'strategy': value.strategy,
        'createdAt': value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
        'createdBy': value.createdBy,
        'assetClass': value.assetClass,
        'numberOfFunds': value.numberOfFunds,
        'userDefinedData': UserDefinedMarketDataToJSON(value.userDefinedData),
        'blendedData': BlendedMarketDataToJSON(value.blendedData),
    };
}
